import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
    name: 'validato'
})

export class ValidatoPipe implements PipeTransform {

    constructor(
        private translateService: TranslateService
    ) {

    }
    /**
     * @param  {any} value
     */
    transform(value: any): string {
        let status: string;
        let translate: string;
        if (value != null) {
            switch (value) {
                case "validato":
                    translate = this.translateService.instant('core.schedaintense.validate');
                    status = '<i class="fas fa-check-circle">'+ translate +'</i>';
                    break;

                case "public":
                    translate = this.translateService.instant('core.status.experiencepublic');
                    status = '<i class="fas fa-globe">'+ translate +'</i>';
                    break;

                case "delete":
                    translate = this.translateService.instant('core.status.experiencearchived');
                    status = '<i class="fas fa-times">'+ translate +'</i>';
                    break;

                case "wait":
                    translate = this.translateService.instant('core.status.experiencewaiting');
                    status = '<i class="fas fa-pause">'+ translate +'</i>';
                    break;
            }
        }
        return status;
    }
}